import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useNavigateRoot } from 'shared/hooks/router';
export function SuccessChangeTariff(props) {
    const { target_tariff } = props;
    const onRoot = useNavigateRoot();
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, boxSizing: "border-box", children: [_jsxs(Alert, { severity: "success", children: ["\u0412\u044B \u043F\u0435\u0440\u0435\u0448\u043B\u0438 \u043D\u0430 \u0442\u0430\u0440\u0438\u0444 ", target_tariff, "!"] }), _jsx(Button, { variant: 'contained', onClick: onRoot, children: "\u0437\u0430\u043A\u0440\u044B\u0442\u044C" })] }));
}
